import React, { useState, useEffect } from "react";
//import {useTranslation} from "react-i18next"
import { Button } from "@mui/material";
//import { set } from "lodash-es"
import { useMutation } from "@apollo/client";
import { ALL_USERS, ACTIVATE_USER, LOCK_USER, DELETE_USER } from "../queries";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
/* eslint-disable react/prop-types */
const Users = ({ setError }) => {
  // eslint-disable-next-line
  //const [t, i18n] = useTranslation("common");
  const [t] = useTranslation("common");
  // eslint-disable-next-line
  const [actived, setActived] = useState("");
  // eslint-disable-next-line
  const [id, setId] = useState("");
  //console.log(setActived);
  //console.log(actived);
  //console.log(id);
  const [email, setEmail] = useState("");
  const [users, setUsers] = useState("");
  //const [name, setName] = useState("");
  //const [address, setAddress] = useState("");
  //const [postnumber, setPostnumber] = useState("");
  //const [postoffice, setPostoffice] = useState("");
  //const [phone, setPhone] = useState("");
  //const [passwordhash, setPassword] = useState("");
  // eslint-disable-next-line
  const [activated, setActivated] = useState(true);
  //console.log(setActivated);
  //const [datetime, setDatetime] = useState("");
  //const [type, setType] = useState("");
  //const [gender, setGender] = useState("");
  //const [born, setBorn] = useState("");
  //const [municipality, setMunicipality] = useState("");
  // eslint-disable-next-line
  const [acceptedtermsofuse, setAccepted] = useState(
    "Sat Feb 27 2025 09:21:48 GMT+0200 (Itä-Euroopan normaaliaika)"
  );
  //console.log(setAccepted);
  //const [country, setCountry] = useState("");
  //const [token, setTokeni] = useState("");
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  //const [executing, setExecuting] = useState(false);
  const [activateUser] = useMutation(ACTIVATE_USER, {
    refetchQueries: [{ query: ALL_USERS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment);
    }*/
  });

  const userss = useQuery(ALL_USERS, {
    pollInterval: 1000000,
  });

  useEffect(() => {
    let usersss = [];
    //let municipalitiess = [];
    if (userss.data) {
      usersss = userss.data.allUsers;
      //setOrgans(organss);
      //console.log(usersss);
      setUsers(usersss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [userss]);
  const [lockUser] = useMutation(LOCK_USER, {
    refetchQueries: [{ query: ALL_USERS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment);
    }*/
  });

  const [deleteUser] = useMutation(DELETE_USER, {
    refetchQueries: [{ query: ALL_USERS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment);
    }*/
  });
  //const [userid, setUserid] = useState("")

  /*const [ createVoting ] = useMutation(CREATE_VOTING, {
    refetchQueries: [  {query: ALL_VOTES} ],
    onError: (error) => {
      
      //setError(error.graphQLErrors[0].message);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment);
    }*/
  //})
  /* const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: { proposalid:event, userid: userid.length > 0 ? userid : "tyhjä", votedatetime:pvm.toString(), sectionid:sectionss }
     })
 
  }
*/

  //let sectionss=1
  /*sectionss = useParams().id
  let valittu = sections.filter(function(el) {
    return el.id===sectionss
  })*/
  /* //console.log(users);
  let valitut = users.filter(function(el) {
    return el.sectionid===sectionss
  });
  */
  //let users =[]
  //console.log(users);
  //setActived(users.activated);
  const setActive = async (event) => {
    //event.preventDefault();
    ////console.log(event);
    setId(users.id);
    setEmail(event);
    setActived(users.activated);
    activateUser({
      variables: { email, activated, acceptedtermsofuse },
    });
    //muutetaan activated !actived edituser
  };
  const setLocked = async (event) => {
    //event.preventDefault();
    ////console.log(event);
    setId(users.id);
    setEmail(event);
    setActived(users.activated);
    lockUser({
      variables: { email: event, locked: true },
    });
    //muutetaan activated !actived edituser
  };
  const setUnlocked = async (event) => {
    //event.preventDefault();
    ////console.log(event);
    setId(users.id);
    setEmail(event);
    setActived(users.activated);
    lockUser({
      variables: { email: event, locked: false },
    });
    //muutetaan activated !actived edituser
  };

  const setDelete = async (event) => {
    //event.preventDefault();
    ////console.log(event);
    deleteUser({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  if (users) {
    return (
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h3>{t("headers.users")}</h3>
              {users.map((prop) => (
                <div key="users">
                  <p>
                    <b>{t("common.name")}</b>
                    {prop.name}
                    <br />
                    <b>{t("common.email")}</b>
                    {prop.email}
                    <br />
                    <b>{t("common.address")}</b>
                    {prop.address}
                    <br />
                    <b>{t("common.postnumber")}</b>
                    {prop.postnumber}
                    <br />
                    <b>{t("common.postoffice")}</b>
                    {prop.postoffice}
                    <br />
                    <b>{t("common.phone")}</b>
                    {prop.phone}
                    <br />
                    <b>{t("common.active")}</b>
                    {prop.activated}
                    <br />
                    <b>{t("common.lock")}</b>
                    {prop.locked}
                    <br />
                    <b>{t("common.usertype")}</b>
                    {prop.type}
                    <br />
                    <b>{t("common.born")}</b>
                    {prop.born}.
                    <br />
                    <b>{t("common.gender")}</b>
                    {prop.gender}
                    <br />
                    <b>{t("common.municipality")}</b>
                    {prop.municipality}
                    <br />
                    <b>{t("common.role")}</b>
                    {prop.role}
                    <br />
                    <b>{t("common.secondarymunicipality")}</b>
                    {prop.secondarymunicipality}
                    <br />
                    <b>{t("user.secondaryrole")}</b>
                    {prop.secondaryrole}
                    <br />
                    <b>{t("common.country")}</b>
                    {prop.country}
                    <br />
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      size="small"
                      type="submit"
                      onClick={() => setUnlocked(prop.email)}
                    >
                      {t("common.unlock")}
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      size="small"
                      type="submit"
                      onClick={() => setLocked(prop.email)}
                    >
                      {t("common.lock")}
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      size="small"
                      type="submit"
                      onClick={() => setActive(prop.email)}
                    >
                      {t("common.active")}
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      size="small"
                      type="submit"
                      onClick={() => {
                        if (window.confirm("Haluatko varmasti poistaa tunnuksen?")) {
                          setDelete(prop.id);
                        }
                      }}
                    >
                      {t("common.delete")}
                    </Button>
                  </p>
                </div>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    );
  } else {
    return (
      <>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                {t("common.nousers")}
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};

export default Users;
